import type { EnumObjectToUnion } from "@/utils/enum";

export const TaskStatus = {
  todo: "todo",
  completed: "completed",
  attachment: "attachment",
  approval: "approval",
  approvalRequired: "approvalRequired",
  approved: "approved",
  notRequired: "notRequired",
} as const;
export type TaskStatus = EnumObjectToUnion<typeof TaskStatus>;
